/** True when TermsGate should overlay the accept modal (not on legal doc pages). */
export function shouldShowTermsAcceptModal(pathname: string | null): boolean {
  const path = pathname || '/';
  return !path.startsWith('/legal/');
}
